import type { ReactNode } from "react";
import { Sparkline } from "../charts/Sparkline";
import styles from "./StatTile.module.css";

interface StatTileProps {
  label: string;
  value: ReactNode;
  /** One line of context under the value: the unit, the comparison, the caveat. */
  sub?: ReactNode;
  trend?: number[];
  icon?: ReactNode;
  emphasis?: boolean;
}

/** Label · value · context · optional 12-point trend — the stat tile contract. */
export function StatTile({ label, value, sub, trend, icon, emphasis }: StatTileProps) {
  return (
    <div className={`${styles.tile} ${emphasis ? styles.emphasis : ""}`}>
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        {icon && <span className={styles.icon}>{icon}</span>}
      </div>
      <div className={styles.valueRow}>
        <span className={styles.value}>{value}</span>
        {trend && trend.length > 1 && <Sparkline values={trend} label={`Tren ${label}`} />}
      </div>
      {sub && <p className={styles.sub}>{sub}</p>}
    </div>
  );
}
